<div class="bg-white ">
<h2 class="header !h-[49px] !pl-[2rem] !flex !items-center !m-0">Approval Request Received</h2>
<!-- Close Icon -->
<div style="position: absolute; top: 15px; right: 18px; width: 20px;">
  <img
    src="assets/icons/cross-icon.svg"
    (click)="closeDialog()"
    alt="cross icon"
    class="cursor-pointer !fixed w-[16px] h-[16px]"
  />
</div>
<div
  class="p-6 !px-[2rem] bg-white rounded-lg shadow-lg w-[100%] mx-auto table-scroll"
  role="dialog"
  aria-labelledby="dialogTitle"
>


  <!-- Loading Overlay -->
  <div
    *ngIf="isLoading"
    class="absolute inset-0 bg-black bg-opacity-30 flex items-center justify-center"
  >
    <mat-spinner diameter="40"></mat-spinner>
  </div>

  <!-- Form Content -->
  <form (ngSubmit)="sendApprovalFeedbackRequest()" #approvalForm="ngForm" >

<div class="py-4 ">
  <table class="min-w-full bg-white border border-gray-200">
    <thead>
      <tr class="bg-[#DEE2E6]">
        <th class="py-2 px-4 text-[#21252A] text-[18px] font-medium  border border-gray-200 text-left w-[20%]">From</th>
        <th class="py-2 px-4 text-[#21252A] text-[18px] font-medium  border border-gray-200 text-left w-[15%]">Role</th>
        <th class="py-2 px-4 text-[#21252A] text-[18px] font-medium border border-gray-200 text-left w-[25%]">Subject</th>
        <th class="py-2 px-4 text-[#21252A] text-[18px] font-medium border border-gray-200 text-left ">Request Description</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let request of requests">
        <td class="py-2 px-4 text-[1rem] text-[#000] font-medium border  border-gray-200">{{ senderDetail?.userName }}</td>
        <td class="py-2 px-4 text-[1rem] text-[#000] font-medium border border-gray-200">{{ request.role }}</td>
        <td class="py-2 px-4 text-[1rem] text-[#000] font-medium border border-gray-200">{{ senderDetail?.userTitle }}</td>
        <td class="py-2 px-4 text-[1rem] text-[#000] font-medium border border-gray-200"
        [innerHTML]="getSanitizedHtml(senderDetail?.description)"
        ></td>
      </tr>
    </tbody>
  </table>
</div>
<!-- Approval Decision Section -->
<div class="mb-6 flex mt-[12px]">
  <label for="decision" class="block font-semibold mt-3 mr-[10px] text-[#21252A] mb-2">
    Select Action
  </label>
  <mat-form-field appearance="outline" class="w-[20vw] h-[56px] ml-[20px]">
    <mat-label>Select</mat-label>
    <mat-select [(ngModel)]="decision" name="decision" id="decision" required aria-label="Select approval decision" >
      <mat-option *ngFor="let option of approvalDecisions" [value]="option" class="!bg-white hover:!bg-[#fae8e1] !py-0 !border-b border-t">
        {{ option | titlecase }}
      </mat-option>
    </mat-select>
    <!-- Mat Error Message -->
<mat-error *ngIf="errorMessage">
{{ errorMessage }}
</mat-error>
  </mat-form-field>
  
</div>
    <!-- Feedback Section -->
    <div class="mb-6">
      <label for="feedback" class="block font-semibold text-[#21252A] mb-2">
        Comments
        <span style="color: red; font-size: 15px">*</span>
      </label>
      <div>
        <app-rich-textEditor
        [placeHolder]="'Comments'"
          id="feedback"
          class="w-full border-gray-300 rounded-md focus:ring focus:ring-blue-500"
          (contentChange)="addNote($event)"
          [resetEditor]="resetRichTextEditor"
          aria-label="Approval feedback"
        ></app-rich-textEditor>
      </div>
    </div>

    
    <!-- Buttons Section -->
    <div class="flex justify-end ">
      <button
        type="button"
        class="bg-[#F1F3F5] text-[1rem] h-[2.5rem] text-[#E76B3F] font-medium px-[15px] rounded-[4px] mr-[10px]  border border-[#E76B3F]"
        (click)="onClose()"
        [disabled]="isLoading"
        aria-label="Close dialog"
      >
        Close
      </button>
      <button
        type="submit"
        class="bg-[#E76B3F] text-[1rem]  px-[22px] h-[2.5rem] text-[#F1F3F5] font-medium  rounded-[4px] shadow-md 
        disabled:bg-[#ADB5BD] disabled:cursor-not-allowed"        
        [disabled]="isLoading || !approvalForm.form.valid || !Comment"
        aria-label="Send approval feedback"
      >
       Send
      </button>
    </div>
  </form>
</div>
</div>